import CommonIOClient from './api/roschat/CommonIOClient'

const proto = new CommonIOClient()


export default proto
